import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PostEntityCreationRuleQueries } from '@admin/data/PostEntityCreationRules'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'
import { Drawer } from '@mui/material'
import { PostEntityCreationRule } from '@admin/PostEntityCreationRule/PostEntityCreationRule'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/rules/$ruleId')({
  component: RouteComponent,
  params: zodValidator(
    z.object({
      ruleId: z.coerce.number(),
    }),
  ),
  loader: async ({ params: { ruleId }, context: { queryClient } }) => {
    await queryClient.ensureQueryData(PostEntityCreationRuleQueries.rule(ruleId))
  },
})

function RouteComponent() {
  const { ruleId } = Route.useParams()
  const { entityType } = Route.useRouteContext()
  const navigate = useNavigate()

  const handleDrawerClose = () => {
    void navigate({ from: Route.fullPath, to: '..' })
  }

  return (
    <Drawer anchor="right" open onClose={handleDrawerClose}>
      <PostEntityCreationRule entityType={entityType} onClose={handleDrawerClose} ruleId={ruleId} />
    </Drawer>
  )
}
